var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { createGlobalStyle } from 'styled-components';
var GlobalStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    * {\n        box-sizing: border-box;\n    }\n    html {\n        scroll-behavior: smooth;\n    }\n"], ["\n    * {\n        box-sizing: border-box;\n    }\n    html {\n        scroll-behavior: smooth;\n    }\n"])));
export default GlobalStyles;
var templateObject_1;
